import { Error } from "@/lib/types/error";

export const hasErrors = (data: Error) : boolean => {
  // Sylius Hydra Errors
  if (data["@type"] && data["@type"] == 'hydra:Error') {
    return true;
  }
  // Sylius Constraint Violation Errors
  if (data["@type"] && data["@type"] == 'ConstraintViolationList') {
    return true;
  }
  return false;
};
